import { render, staticRenderFns } from "./CreateSubject.vue?vue&type=template&id=2026b0a6&scoped=true&"
import script from "./CreateSubject.vue?vue&type=script&lang=js&"
export * from "./CreateSubject.vue?vue&type=script&lang=js&"
import style0 from "./CreateSubject.vue?vue&type=style&index=0&id=2026b0a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2026b0a6",
  null
  
)

export default component.exports